import { Component, createRef } from 'react';

import FormInputComponent from '../../../components/ui/forms/form-input/form-input.component';
import Modal from '../../../components/ui/modal/modal.component';
import { IOC_TYPES } from '../../../context/ioc.types';
import { lazyInject } from '../../../context/module';
import { FormControl } from '../../../models/forms';
import { LightHttp } from '../../../services/light-http.service';
import { UIContext } from '../../../services/ui-context';
import { FileUtils } from '../../../utils/file-utils';
import { reloadAfterExecute } from '../../../utils/react.utils';
import FileUploadComponent from '../../converter/file-upload/file-upload.component';
import { MemeSourceImage } from '../meme-source-image';
import type { FileSelectEvent } from '../../../types/file-upload.types';


interface MemeModalComponentProps {
    selectCallback;
}

export class MemeModalComponent extends Component<MemeModalComponentProps> {
    modalRef = createRef<Modal>();

    memeSoruceImages: MemeSourceImage[];
    filteredMemeSoruceImages: MemeSourceImage[] = [];
    searchText = '';
    searchTextControl: FormControl = new FormControl('');
    totalItems = 100;
    itemsPerPage = 60;
    currentPage = 1;
    page: number;

    static show(props: MemeModalComponentProps) {
        Modal.createModal(MemeModalComponent, props);
    }

    @lazyInject(IOC_TYPES.LightHttp) private http: LightHttp;
    @lazyInject(IOC_TYPES.UIContext) private uiContext: UIContext;

    constructor(props: MemeModalComponentProps) {
        super(props);
        this.http.get<string>('meme/names.txt', { responseType: 'text' }).subscribe(data => {
            this.memeSoruceImages = data.split('\n').map(line => {
                const memeLine = line.split('\t');
                return new MemeSourceImage(memeLine[2], memeLine[0]);
            });
            this.totalItems = this.memeSoruceImages.length;
            this.updateFilteredMemeImages(undefined);
        });

        this.searchTextControl.valueChanges.subscribe(
            data => {
                this.updateFilteredMemeImages(data);
            },
        );
    }

    @reloadAfterExecute()
    selectMemeImage(memeSoruceImage: MemeSourceImage) {
        this.modalRef.current.unmount();
        if (this.props.selectCallback) {
            this.props.selectCallback(memeSoruceImage);
        }
    }

    getCurrentPageMemeImages() {
        const start = (this.currentPage - 1) * this.itemsPerPage;
        return this.filteredMemeSoruceImages.slice(start, start + this.itemsPerPage);
    }

    @reloadAfterExecute()
    updateFilteredMemeImages(filterText: string) {
        if (!filterText || filterText.length === 0) {
            this.filteredMemeSoruceImages = this.memeSoruceImages;
        } else {
            const searchTextSplit = filterText.split(' ');
            this.filteredMemeSoruceImages = this.memeSoruceImages.filter(im => {
                if (im.memeName) {
                    const imageNameSplit = im.memeName.split(' ');
                    for (const s of imageNameSplit) {
                        const t = searchTextSplit.find(_s => s.toLocaleLowerCase().indexOf(_s.toLocaleLowerCase()) === 0);
                        if (t) {
                            return true;
                        }
                    }
                }
            });
        }
    }

    @reloadAfterExecute()
    uploadImage(event: FileSelectEvent) {
        this.modalRef.current.unmount();
        const file = event.files[0];
        if (file instanceof File) {
            FileUtils.fileToJpgImage(file).then(img => {
                if (this.props.selectCallback) {
                    const sImage = new MemeSourceImage(img.src, img);
                    this.props.selectCallback(sImage);
                }
            });
        } else {
            this.uiContext.errorToast('Error', 'Unsupported File!');
        }
    }

    @reloadAfterExecute()
    pageChanged(event: any): void {
        this.page = event.page;
    }

    onOpen(modal: Modal) {
        console.log('onOpen', modal);
    }

    onClose(modal: Modal) {
        console.log('onClose', modal);
    }

    render() {
        return <Modal ref={this.modalRef} onClose={(e) => this.onClose(e)} onOpen={(e) => this.onOpen(e)}>
            <div data-modalheader>
                <h2 className="modal-title">Meme Templates</h2>
                <FileUploadComponent fileSelected={$event => this.uploadImage($event)}
                    fileSelectButtonClicked={() => console.log('fileSelectButtonClicked from dom')}
                    acceptedFileTypes="image/*"
                    uploadBtnText="Select Image"
                    showDropbox={false} showGoogleDrive={false}>
                </FileUploadComponent>
                <div className="input-group mb-3">
                    <FormInputComponent
                        type="text" className="form-control" control={this.searchTextControl} placeholder="Search Meme Image..."
                        aria-label="Meme Image" aria-describedby="button-addon2">
                    </FormInputComponent>
                    <div className="input-group-append">
                        <button className="btn btn-outline-secondary" type="button" id="button-addon2"
                            onClick={($event) => this.updateFilteredMemeImages(undefined)}>Clear</button>
                    </div>
                </div>
            </div>
            <div data-modalbody>

                <div className="row">
                    <div className="col-xs-12 col-12">
                        {/* <pagination [totalItems]="filteredMemeSoruceImages.length" [itemsPerPage]="itemsPerPage"
                            [(ngModel)]="currentPage"></pagination> */}
                    </div>
                </div>
                {
                    this.memeSoruceImages && <div className="row">
                        {
                            this.getCurrentPageMemeImages().map(memeSoruceImage => {
                                return <div className="col-md-3 meme-image-container">
                                    <div className="meme-image">
                                        <div>
                                            <b>{memeSoruceImage.memeName}</b>
                                        </div>
                                        <img src={memeSoruceImage.thumbImageUrl} />
                                        <div className="select-btn">
                                            <button type="button" className="btn btn-primary btn-sm"
                                                onClick={($event) => this.selectMemeImage(memeSoruceImage)}>Select</button>
                                        </div>
                                    </div>
                                </div>
                            })
                        }
                    </div>
                }

                <div className="row">
                    <div className="col-xs-12 col-12">
                        {/* <pagination [totalItems]="filteredMemeSoruceImages.length" [itemsPerPage]="itemsPerPage"
                            [(ngModel)]="currentPage"></pagination> */}
                    </div>
                </div>
            </div>
        </Modal>
    }
}
